import { type MoveEvent, PORTALS } from '@chessbut/engine';
import type { Decoration, VariantUi } from './ui.ts';

const PORTAL_ART = ['/art/portal-a.svg', '/art/portal-b.svg'];
const warped = (e: MoveEvent) => e.t === 'fx' && e.kind === 'portal';
const TILES: Decoration[] = PORTALS.map((sq, i) => ({ kind: 'tile', sq, image: PORTAL_ART[i], title: 'Portal' }));

export const portalUi: VariantUi = {
  heroImage: '/art/portals.svg',
  peek: [{}, {}, { image: PORTAL_ART[1] }, {}, { image: '/art/bK.svg', threat: true }, {}, { image: PORTAL_ART[0] }, {}, { image: '/art/wQ.svg' }],

  decorations() {
    return TILES;
  },

  twist() {
    return { text: 'Rooks, bishops and queens can slide through the portals on c4 and f5' };
  },

  eventSound(e) {
    return warped(e) ? 'warp' : null;
  },

  moveBadge(rec) {
    return rec.events.some(warped) ? { icon: '/art/portals.svg', victim: rec.captured || undefined, title: 'Through a portal' } : null;
  },
};
